import { gql, useQuery } from '@apollo/client';

type ScenarioLinkedControlsCheckData = {
  scenario?: {
    id: string;
    riskManagementPlans: Array<{
      id: string;
      control?: {
        id: string;
        frameworkControls?: Array<{
          id: string;
          control_identifier?: string | null;
        } | null> | null;
      } | null;
    }>;
  } | null;
};

type ScenarioLinkedControlsCheckVariables = {
  id: string;
};

export const SCENARIO_LINKED_CONTROLS_CHECK = gql`
  query scenarioLinkedControlsCheck($id: UxId!) {
    scenario(id: $id) {
      id
      riskManagementPlans {
        id
        control {
          id
          frameworkControls {
            id
            control_identifier
          }
        }
      }
    }
  }
`;

export const useScenarioLinkedControlsCheckQuery = (id: string) =>
  useQuery<ScenarioLinkedControlsCheckData, ScenarioLinkedControlsCheckVariables>(SCENARIO_LINKED_CONTROLS_CHECK, {
    variables: { id },
  });
